import { observable, action } from "mobx";
import agent from "../agent";
import authStore from "./authStore";
import gameStore from "./gameStore";
import { $util, $const } from "../helper";
import { message } from "antd";

class teamStore {
  @observable teamInfo = {};
  @observable createTeamInfo = {};
  @observable updateGteam = {};
  @observable myTeams = [];
  @observable myTeamsLoading = false;
  @observable joinInTeamInfo = {};
  @observable teamIsLocked = false;
  @observable selectRole = false;
  @observable registrationId = null;
  @observable applicationTeamInfo = undefined;
  // 所有学校的信息是否满足要求
  @observable allInfoIsLegal = true;
  @observable updateManagementMarkInfo = undefined;
  @observable errApplicationTeamInfo = {
    isJoinTeamFail: false
  }; // 加入队伍时出错的提示
  @observable myApplication = [];
  @observable stageMap = {
    id: 0
  };
  @observable quiz = {
    id: 0
  };
  @observable createQuizList = {
    id: 0
  };
  // 当前队伍的所属学校信息
  @observable schoolsInfo = null;
  // 当前队伍的队伍tag
  @observable teamTags = null;
  // 选择队伍弹框
  @observable selectBBSTeamModalState = false;
  // 选择的队伍id
  @observable currentSelectBBSTeamId = undefined;
  // 当前队伍详情的队伍是否是“机甲大师高校联盟赛”和”机甲大师超级对抗赛“
  @observable currentTeamIsSpecialGame = false;
  @observable applyTipsBBSState = false;
  // 当前队伍当前环节是否为收集名单环节
  @observable showCollectionStage = false;
  @observable collectionStrategyId = void 0;
  @observable collectionId = void 0;

  @action setShowCollectionState(state) {
    this.showCollectionStage = state;
  }

  @action resetCollectionInfoData() {
    this.showCollectionStage = false;
    this.collectionStrategyId = void 0;
    this.collectionId = void 0;
  }

  @action setCollectionStrategyId(id) {
    this.collectionStrategyId = id;
  }

  @action setCollectionId(id) {
    this.collectionId = id;
  }

  @action setApplyTipsBBSState(state) {
    this.applyTipsBBSState = state;
  }

  @action setCurrentTeamIsSpecialGame(state) {
    this.currentTeamIsSpecialGame = state;
  }

  @action setCurrentSelectBBSTeamId(teamId) {
    this.currentSelectBBSTeamId = teamId;
  }

  @action setSelectBBSTeamModalState(state) {
    this.selectBBSTeamModalState = state;
  }

  @action resetTeamInfo() {
    this.teamInfo = {};
  }
  @action resetQuiz() {
    this.stageMap = {
      id: 0
    };
  }
  @action resetStageMap() {
    this.stageMap = {
      id: 0
    };
  }

  @action setAllInfoLegalState(result) {
    this.allInfoIsLegal = result;
  }

  @action resetSchoolsInfo() {
    this.schoolsInfo = null;
  }

  @action getSchoolsInfo(id) {
    return agent.SassPlatform.getSchoolsInfoByTeamId(id).then(
      action(res => {
        if (res && res.success && Array.isArray(res.data) && res.data.length > 0) {
          this.schoolsInfo = res.data;
        }
        return;
      })
    );
  }

  @action getTeamInfo(id) {
    return Promise.all([
      agent.Teams.getTeamInfoById({
        variables: {
          id: id
        }
      }),
      agent.SassPlatform.getSchoolsInfoByTeamId(id)
    ])
      .then(
        action(([res, resSchools]) => {
          if (
            res &&
            res.data &&
            res.data.team &&
            Array.isArray(resSchools.data) &&
            resSchools.data.length > 0
          ) {
            this.schoolsInfo = resSchools.data;
            const teamTags = $util.getTeamTagBySchools(resSchools.data);
            this.teamTags = teamTags;
            this.teamInfo = res.data.team;
            this.teamInfo.positionLimit = $util.formatTeamPosition(this.teamInfo);
            if (!this.teamInfo.collegeId && this.schoolsInfo && this.schoolsInfo.length > 0) {
              this.teamInfo.collegeId = this.schoolsInfo[0].id;
            }
            if (this.teamInfo.collegeId && this.teamInfo.college) {
              this.teamInfo.college.tags = teamTags;
            }
            // 获取比赛流程
            this.teamInfo.myFlow = $util.getTeamFlow(this.teamInfo);
            this.teamInfo.myFlow.eventId = this.teamInfo.gevent && this.teamInfo.gevent.id;
            // 比赛节点排序
            if (
              this.teamInfo.myFlow &&
              this.teamInfo.myFlow.stages &&
              this.teamInfo.myFlow.stages.nodes
            ) {
              this.teamInfo.myFlow.stages.nodes = this.teamInfo.myFlow.stages.nodes.sort(function(
                a,
                b
              ) {
                return (
                  a.majorNum * 10 +
                  (a.minorNum ? a.minorNum : 0) -
                  (b.majorNum * 10 + (b.minorNum ? b.minorNum : 0))
                );
              });
              let length = this.teamInfo.myFlow.stages.nodes.length;
              // 节点里的表单项排序
              for (let i = 0; i < length; i++) {
                if (
                  this.teamInfo.myFlow.stages.nodes[i].forms &&
                  this.teamInfo.myFlow.stages.nodes[i].forms.nodes &&
                  this.teamInfo.myFlow.stages.nodes[i].forms.nodes[0]
                ) {
                  if (
                    this.teamInfo.myFlow.stages.nodes[i].forms.nodes[0].formInputs &&
                    this.teamInfo.myFlow.stages.nodes[i].forms.nodes[0].formInputs.nodes
                  ) {
                    this.teamInfo.myFlow.stages.nodes[
                      i
                    ].forms.nodes[0].formInputs.nodes = this.teamInfo.myFlow.stages.nodes[
                      i
                    ].forms.nodes[0].formInputs.nodes.sort(function(a, b) {
                      return a.orderNum - b.orderNum;
                    });
                  }
                }
              }
            }
            // 检查是否为队长
            if ($util.checkIsCaptain(this.teamInfo, authStore.user)) {
              this.teamInfo.isCaptain = true;
            }
            // 检查是否为副队长
            if ($util.checkIsSubCaptain(this.teamInfo, authStore.user)) {
              this.teamInfo.isSubCaptain = true;
            }
            // 是否有比赛提交记录
            if (
              this.teamInfo &&
              this.teamInfo.registrations &&
              this.teamInfo.registrations.nodes &&
              this.teamInfo.registrations.nodes[0]
            ) {
              this.teamInfo.gameData = this.teamInfo.registrations.nodes[0];
              this.registrationId = this.teamInfo.registrations.nodes[0].id;
              // 当前处于哪个环节
              this.teamInfo.stageId = this.teamInfo.registrations.nodes[0].stageId;
              // 当前是否完成参赛反馈环节
              this.teamInfo.isComplete = $util.checkIsComplete(
                this.teamInfo.myFlow.stages.nodes,
                this.teamInfo.gameData
              );
              let stageIdMajorNum = 0;
              this.teamInfo.myFlow &&
                this.teamInfo.myFlow.stages.nodes.forEach(node => {
                  if (node.id === this.teamInfo.stageId) {
                    stageIdMajorNum = node.majorNum;
                  }
                });
              this.teamInfo.stageIdMajorNum = stageIdMajorNum;
              // 如果有比赛状态产生 梳理他的状态
              if (
                this.teamInfo.myFlow &&
                this.teamInfo.registrations.nodes[0].registrationStageStatuses &&
                this.teamInfo.registrations.nodes[0].registrationStageStatuses.nodes
              ) {
                $util.formatStageStatus(
                  this.teamInfo.myFlow.stages.nodes,
                  this.teamInfo.registrations.nodes[0].registrationStageStatuses.nodes
                );
              }
            } else {
              this.registrationId = null;
              this.gameData = null;
            }
          }
        })
      )
      .catch(error => {
        console.error(error);
        message.error("获取队伍信息失败，请刷新页面重试。");
      });
  }

  @action createTeam(team) {
    return agent.Teams.create(team).then(
      action(res => {
        let data = res.data && res.data.createGteam && res.data.createGteam.gteam;
        if (data) {
          this.createTeamInfo = {
            name: data.name,
            collegeName: team.input.attributes.collegeName,
            inviteCode: data.inviteCode,
            id: data.id,
            teamType: team.input.attributes.teamType
          };
        } else if (res.errors) {
          return Promise.reject(res.errors);
        }
      })
    );
  }

  @action updateTeam(team) {
    return agent.Teams.updateTeam(team).then(
      action(res => {
        let data = res.data && res.data.updateGteam && res.data.updateGteam.gteam;
        if (data) {
          this.teamInfo.college = data.college;
          this.teamInfo.collegeAbbreviation = data.collegeAbbreviation;
          this.teamInfo.collegeBadge = data.collegeBadge;
          this.teamInfo.collegeId = data.collegeId;
          this.teamInfo.collegeName = data.collegeName;
          this.teamInfo.consigneeAddress = data.consigneeAddress;
          this.teamInfo.consigneeCityCode = data.consigneeCityCode;
          this.teamInfo.consigneeCountryCode = data.consigneeCountryCode;
          this.teamInfo.consigneeDistrictCode = data.consigneeDistrictCode;
          this.teamInfo.consigneeName = data.consigneeName;
          this.teamInfo.consigneePhone = data.consigneePhone;
          this.teamInfo.consigneeProvinceCode = data.consigneeProvinceCode;
          this.teamInfo.name = data.name;
          this.teamInfo.teamType = data.teamType;
          this.teamInfo.district = data.district;
        } else if (res.errors) {
          return Promise.reject(res.errors);
        } else {
          return Promise.reject(res.msg);
        }
      })
    );
  }

  @action getMyTeams() {
    this.myTeamsLoading = true;
    return agent.Teams.getMyTeams()
      .then(
        action(res => {
          if (
            res &&
            res.data &&
            res.data.member &&
            res.data.member.gteams &&
            res.data.member.gteams.nodes
          ) {
            this.myTeams = res.data.member.gteams.nodes;
          }
        })
      )
      .finally(
        action(() => {
          this.myTeamsLoading = false;
        })
      );
  }

  @action joinInTeam(application) {
    return agent.Teams.joinInTeam(application)
      .then(
        action(res => {
          // 报名时出错，可能用户已经登出，或换了个账号登陆
          if (res.status && res.msg) {
            this.errApplicationTeamInfo.status = res.status;
            this.errApplicationTeamInfo.msg = res.msg;
            this.errApplicationTeamInfo.isJoinTeamFail = true;
            this.selectRole = false;
          }
          if (res && res.data && res.data.createGapplication) {
            this.applicationTeamInfo = res.data.createGapplication;
            this.applicationTeamInfo.eventRoleId =
              application.variables.input.attributes.eventRoleId;
            this.applicationTeamInfo.eventPositionId =
              application.variables.input.attributes.eventPositionId;
          }
        })
      )
      .finally(
        action(() => {
          this.myTeamsLoading = false;
        })
      );
  }

  @action searchTeam(code) {
    return agent.Teams.searchTeam({
      variables: {
        input: code
      }
    }).then(
      action(res => {
        if (res.data && res.data.teams && res.data.teams.nodes) {
          this.joinInTeamInfo = res.data.teams.nodes[0];
          if (this.joinInTeamInfo && this.joinInTeamInfo.id) {
            if (this.joinInTeamInfo.status === $const.TEAM_STATUS.LOCKED) {
              this.teamIsLocked = true;
            } else if (
              !this.joinInTeamInfo.gevent ||
              this.joinInTeamInfo.gevent.id !== gameStore.selectedGame.id
            ) {
              this.joinInTeamInfo.teamIsWrong = true;
            } else {
              this.selectRole = true;
            }
          }
        }
      })
    );
  }

  @action showTeamIsLocked() {
    this.teamIsLocked = true;
  }

  @action closeTeamIsLocked() {
    this.teamIsLocked = false;
  }

  @action closeSelctRole() {
    this.selectRole = false;
  }

  @action changeInvitationCode(id) {
    return agent.Teams.updateInviteCode({
      input: {
        id: id
      }
    }).then(
      action(res => {
        if (res && res.data && res.data.updateGteam && res.data.updateGteam.gteam) {
          this.teamInfo.inviteCode = res.data.updateGteam.gteam.inviteCode;
        }
      })
    );
  }

  @action updateTeamMemberApplication(application, notCaptain) {
    return agent.Teams.updateMemberApplication(application).then(
      action(() => {
        if (!notCaptain) {
          this.getTeamInfo(this.teamInfo.id);
        }
      })
    );
  }

  @action updateTeamMember(member) {
    return agent.Teams.updateTeamMember(member).then(
      action(res => {
        this.getTeamInfo(this.teamInfo.id);
      })
    );
  }

  @action lockTeam(team) {
    return agent.Teams.lockTeam(team).then(
      action(res => {
        this.getTeamInfo(this.teamInfo.id);
      })
    );
  }

  @action exitTeam(member) {
    return agent.Teams.exitTeam(member).then(
      action(res => {
        // this.getTeamInfo(this.teamInfo.id)
      })
    );
  }

  @action deleteTeam(team) {
    return agent.Teams.deleteTeam(team).then(action(res => {}));
  }
  @action changeCaptain(info) {
    return agent.Teams.changeCaptain(info).then(
      action(res => {
        this.getTeamInfo(this.teamInfo.id);
      })
    );
  }

  @action updateManagementMark(id, marker) {
    return agent.Teams.updateManagementMark(id, marker).then(
      action(res => {
        this.updateManagementMarkInfo = res;
      })
    );
  }

  // 获取申请信息
  @action getApplication() {
    return agent.Teams.getApplication().then(
      action(res => {
        if (res && res.data && res.data.applications && res.data.applications.nodes) {
          this.myApplication = res.data.applications.nodes;
        }
      })
    );
  }

  // 同时设置jointeaminfo  applicationTeamInfo

  @action setApplicationTeamInfo(team, application) {
    this.joinInTeamInfo = team;
    this.applicationTeamInfo = application;
  }

  @action createQuiz(registrationStageStatusId, lang) {
    return agent.Teams.createQuiz(
      {
        variables: {
          input: {
            attributes: {
              registrationStageStatusId: registrationStageStatusId
            }
          }
        }
      },
      lang
    ).then(
      action(res => {
        if (res && res.data && res.data.createQuiz && res.data.createQuiz.quiz) {
          let item = {};
          item[registrationStageStatusId] = res.data.createQuiz.quiz;
          this.createQuizList = Object.assign({}, this.createQuizList, item);
        }
      })
    );
  }

  @action getQuizConfig(registrationStageStatusId, stageId) {
    return agent.Teams.getQuizConf({
      variables: {
        stageId: stageId
      }
    }).then(
      action(res => {
        if (res && res.data && res.data.quizConfigs && res.data.quizConfigs.nodes) {
          let quizIteam = this.quiz[registrationStageStatusId] || {};
          this.stageMap[stageId] = res.data.quizConfigs.nodes[0];
          this.stageMap.id++;
          quizIteam.config = res.data.quizConfigs.nodes[0];
          this.quiz[registrationStageStatusId] = Object.assign({}, quizIteam);
          this.quiz.id++;
          if (quizIteam.config && quizIteam.config.forMultiPeople) {
            return agent.Teams.getQuizeRoundHistory({
              variables: {
                registrationStageStatusId: registrationStageStatusId
              }
            }).then(
              action(res => {
                if (res && res.data && res.data.quizRounds && res.data.quizRounds.nodes) {
                  let quizIteam = this.quiz[registrationStageStatusId] || {};
                  quizIteam.history = res.data.quizRounds.nodes;
                  this.quiz[registrationStageStatusId] = Object.assign({}, quizIteam);
                  this.quiz.id++;
                }
              })
            );
          }
        }
      })
    );
  }

  @action getQuizeHistory(registrationStageStatusId, stageId, isPendingOrProgress, isAuto) {
    return agent.Teams.getQuizConf({
      variables: {
        stageId: stageId
      }
    }).then(
      action(res => {
        if (res && res.data && res.data.quizConfigs && res.data.quizConfigs.nodes) {
          let quizIteam = this.quiz[registrationStageStatusId] || {};
          this.stageMap[stageId] = res.data.quizConfigs.nodes[0];
          this.stageMap.id++;
          quizIteam.config = res.data.quizConfigs.nodes[0];
          this.quiz[registrationStageStatusId] = Object.assign({}, quizIteam);
          this.quiz.id++;
          if (quizIteam.config && quizIteam.config.forMultiPeople) {
            return agent.Teams.getQuizeRoundHistory({
              variables: {
                registrationStageStatusId: registrationStageStatusId
              }
            }).then(
              action(res => {
                if (res && res.data && res.data.quizRounds && res.data.quizRounds.nodes) {
                  let quizIteam = this.quiz[registrationStageStatusId] || {};
                  quizIteam.history = res.data.quizRounds.nodes;
                  quizIteam.isAuto = isAuto;
                  this.quiz[registrationStageStatusId] = Object.assign({}, quizIteam);
                  this.quiz.id++;
                }
              })
            );
          }
          if (isPendingOrProgress) {
            // 不等于pass 和 fail才去请求
            return agent.Teams.getQuizeHistory({
              variables: {
                registrationStageStatusId: registrationStageStatusId
              }
            }).then(
              action(res => {
                if (res && res.data && res.data.quizzes && res.data.quizzes.nodes) {
                  let quizIteam = this.quiz[registrationStageStatusId] || {};
                  quizIteam.history = res.data.quizzes.nodes;
                  quizIteam.isAuto = isAuto;
                  this.quiz[registrationStageStatusId] = Object.assign({}, quizIteam);
                  this.quiz.id++;
                }
              })
            );
          }
        }
      })
    );
  }
}

export default new teamStore();



// WEBPACK FOOTER //
// ./src/stores/teamStore.js